// -----------------------------------------------------------------------------
// -----------------------------------------------------------------------------
export class CookieUtils {
  // ---------------------------------------------------------------------------
  public static getCookie(name: string): string {
    const dc = document.cookie;
    const prefix = name + '=';
    let begin = dc.indexOf('; ' + prefix);
    let end: number;
    if (begin == -1) {
      begin = dc.indexOf(prefix);
      const indexOfEnd = document.cookie.indexOf(';', begin);
      end = indexOfEnd === -1 ? undefined : indexOfEnd;
      if (begin != 0) return null;
    } else {
      begin += 2;
      end = document.cookie.indexOf(';', begin);
      if (end == -1) {
        end = dc.length;
      }
    }

    return decodeURI(dc.substring(begin + prefix.length, end));
  }

  // ---------------------------------------------------------------------------
  public static deleteCookie(name: string, path: string = '/'): void {
    const isLocalhost =
      typeof window !== 'undefined' &&
      (window.location.hostname === 'localhost' ||
        window.location.hostname === '127.0.0.1');
    const domain = isLocalhost ? '' : '; domain=.overwolf.com';

    document.cookie = `${name}=; Max-Age=0; path=${path}${domain}`;
  }

  // ---------------------------------------------------------------------------
  public static setCookie(
    name: string,
    value: string,
    days: number = 365,
    path: string = '/',
  ): void {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = `; expires=${date.toUTCString()}`;
    }
    
    const isLocalhost = typeof window !== 'undefined' && 
      (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
    const domain = isLocalhost ? '' : '; domain=.overwolf.com';
    
    document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=${path}${domain}`;
  }
}
